<template>
	<div>
		<!-- Start Tab栏 -->
		<div class="row row--15">
			<div class="col-lg-12">
				<ul class="nav nav-pills rwt-portfolio-filter filter-button-default liststyle mb--20" id="pills-tab"
					role="tablist" data-aos="fade-up">
					<li class="nav-item list-item" role="presentation" v-for="(filter, index) in filters"
						:key="`tab-button-${filter.id}`">
						<button class="nav-link" :class="{'active': index === 0}" :id="`pills-${filter.sign}-tab`"
							data-bs-toggle="pill" :data-bs-target="`#pills-${filter.sign}`" type="button" role="tab"
							:aria-controls="`pills-${filter.sign}`"
							:aria-selected="index === activeTab ? 'true' : 'false'" @click="activeTab = index">
							{{ filter.text }}
						</button>
					</li>
				</ul>
			</div>
		</div>
		<!-- end Tab栏 -->

		<div class="tab-content" id="pills-tabContent">
			<div class="tab-pane fade" :class="{'show active': index === 0}" :id="`pills-${filter.sign}`"
				role="tabpanel" :aria-labelledby="`pills-${filter.sign}-tab`" v-for="(filter, index) in filters"
				:key="`tab-pane-${filter.id}`">
				<div class="row row--15">
					
					<!-- start 概述 -->
					<template v-if="filter.sign == 'all'">
						<div class="portfolio">
							<div class="container">
								<div class="row row--40 align-items-center">
									<div class="col-lg-4">
										<img v-for="img in SerialAllInfo.imgsPath" class="w-100" :src="img" >
									</div>
									<div class="col-lg-8 mt_md--40 mt_sm--40">
										<div class="content">
											<div class="inner">
												<h3 class="title"><strong>{{SerialAllInfo.SerialName}}</strong></h3>
												<p>
													<span v-html="SerialAllInfo.SerialIntro"></span>
												</p>
												<ul class="feature-list">
													<li v-for="item in SerialAllInfo.TypeInfo">
														<!-- <Icon name="check" size="20" icon-class="icon" /> -->
														<div class="title-wrapper">
															<h4 class="title">{{item.TypeName}}</h4>
															<p class="text">
																<span v-html="item.TypeIntro"></span>
															</p>
														</div>
													</li>													
												</ul>												
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</template>
					<!-- end 概述 -->
					
					<!-- start 参数详细 -->
					<template v-if="filter.sign == 'params'">
						<div class="portfolio">
							<div class="container">
								<div class="row row--40 align-items-center">
									<div class="col-lg-12">
										<p class="text">
											<span v-html="SerialAllInfo.ParaTable"></span>
										</p>
									</div>
								</div>
							</div>
						</div>
					</template>
					<!-- end 参数详细 -->
					
					<!-- start 资料下载 -->
					<template v-if="filter.sign == 'download'">
						<div class="portfolio">
							<div class="container">
								<div class="row">
									<UpDownTool :file-list="SerialAllInfo.DownloadList"></UpDownTool>
								</div>
							</div>
						</div>
					</template>
					<!-- end 资料下载 -->
					
					<!-- start 常见问题 -->
					<template v-if="filter.sign == 'qa'">
						<div class="portfolio">
							<div class="container">
								<div class="row row--40 align-items-center">
									<div class="col-lg-12">
										
									</div>									
								</div>
							</div>
						</div>
					</template>
					<!-- end 常见问题 -->
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	import Icon from '../../icon/Icon'
	import UpDownTool from '../../updown/updownlist.vue'
	import BlogPostMixin from '../../../mixins/BlogPostMixin'
	import PDetailMixin from '../../../mixins/EdgeProductDetailInfo.js'

	export default {
		name: 'Portfolio',
		components: {
			Icon,UpDownTool
		},
		mixins: [BlogPostMixin,PDetailMixin],
		props: {
			portfolioData: {},
			buttonClass: {
				type: String,
				default: 'btn btn-default btn-large btn-icon'
			},
			column: {
				type: String,
				default: 'col-lg-6 col-md-6 col-sm-12 col-12 mt--30'
			}
		},
		data() {
			return {
				filters: [
					{
						id: 1,
						sign: 'all',
						text: '概述',
					},
					{
						id: 2,
						sign: 'params',
						text: '参数详细',
					},
					{
						id: 3,
						sign: 'download',
						text: '资料下载',
					},
					{
						id: 4,
						sign: 'qa',
						text: '常见问题',
					},
				],
				
				activeFilter: '',
				activeTab: 0,
			}
		},
		methods:{
			getFilters(typeID){
				let data = [];
				if(typeID == 53){
					data = [
						{
							id: 1,
							sign: 'all',
							text: '概述',
						},
						{
							id: 2,
							sign: 'params',
							text: '参数详细',
						},
						{
							id: 3,
							sign: 'download',
							text: '资料下载',
						},
						{
							id: 4,
							sign: 'qa',
							text: '常见问题',
						},
					]
				}
				else{
					data = [
						{
							id: 1,
							sign: 'all',
							text: '概述',
						},
						{
							id: 2,
							sign: 'params',
							text: '参数详细',
						},
						{
							id: 3,
							sign: 'download',
							text: '资料下载',
						},
						{
							id: 4,
							sign: 'qa',
							text: '常见问题',
						},
					]
				}
			}
		},
		created() {
			// console.log('this.$route.params.typeID='+this.$route.params.typeID)
			
			this.getProductDetailData(this.$route.params.typeID);
		}
	}
</script>

<style>

	.para-table table{
		border: 1;
		align:center;
		border-collapse: collapse
	}
	.para-table td{
		border:1px solid #212529;
		font-size: 18px !important;
		border-collapse: collapse;
		text-align: center;
		color: black;
	}
	.para-table font{
		text-align: center;
	}
	.para-table-head td{
		background-color: #003366;
		color: #ffffff;
	}
	.para-table-tag{
		background-color: #99CCFF
	}

</style>